import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getHealthProfileForAdmin = userId =>
  call(websocketFetch, 'get_health_profile_for_admin', { user_id: userId });
